import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const QuickActionToolbar = ({ className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const quickActions = [
    { 
      label: 'New Search', 
      icon: 'Search', 
      action: () => window.location.href = '/crane-search-dashboard',
      primary: true 
    },
    { 
      label: 'Saved Searches', 
      icon: 'Bookmark', 
      action: () => console.log('Open saved searches'),
      count: 3 
    },
    { 
      label: 'Recent Reports', 
      icon: 'FileText', 
      action: () => console.log('Open recent reports'),
      count: 5 
    },
    { 
      label: 'Quick Compare', 
      icon: 'GitCompare', 
      action: () => window.location.href = '/comparison-tool' 
    },
  ];

  const moreActions = [
    { label: 'Export Data', icon: 'Download', action: () => console.log('Export data') },
    { label: 'Import List', icon: 'Upload', action: () => console.log('Import list') },
    { label: 'Share Report', icon: 'Share2', action: () => console.log('Share report') },
  ];

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`bg-surface border-b border-border ${className}`}>
      <div className="px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Primary Quick Actions */}
          <div className="flex items-center space-x-3">
            {quickActions?.slice(0, 3)?.map((action, index) => (
              <Button
                key={index}
                variant={action?.primary ? "default" : "outline"}
                size="sm"
                onClick={action?.action}
                iconName={action?.icon}
                iconPosition="left"
                className="relative"
              >
                {action?.label}
                {action?.count && (
                  <span className="ml-2 px-1.5 py-0.5 text-xs bg-accent text-accent-foreground rounded-full">
                    {action?.count}
                  </span>
                )}
              </Button>
            ))}
            
            {/* Mobile: Show only primary action */}
            <div className="md:hidden">
              <Button
                variant="outline"
                size="sm"
                onClick={toggleExpanded}
                iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
                iconPosition="right"
              >
                More
              </Button>
            </div>
          </div>

          {/* Desktop: Additional Actions */}
          <div className="hidden md:flex items-center space-x-2">
            {quickActions?.slice(3)?.map((action, index) => (
              <Button
                key={index}
                variant="ghost"
                size="sm"
                onClick={action?.action}
                iconName={action?.icon}
              >
                {action?.label}
              </Button>
            ))}
            
            {/* More Actions Dropdown */}
            <div className="relative">
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleExpanded}
                iconName="MoreVertical"
              />
              
              {isExpanded && (
                <div className="absolute right-0 mt-2 w-48 bg-popover border border-border rounded-md shadow-dropdown z-300">
                  <div className="py-1">
                    {moreActions?.map((action, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          action?.action();
                          setIsExpanded(false);
                        }}
                        className="flex items-center space-x-2 w-full px-4 py-2 text-sm text-text-secondary hover:text-primary hover:bg-muted transition-smooth"
                      >
                        <Icon name={action?.icon} size={16} />
                        <span>{action?.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile: Expanded Actions */}
        {isExpanded && (
          <div className="md:hidden mt-3 pt-3 border-t border-border">
            <div className="grid grid-cols-2 gap-2">
              {[...quickActions?.slice(3), ...moreActions]?.map((action, index) => (
                <Button
                  key={index}
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    action?.action();
                    setIsExpanded(false);
                  }}
                  iconName={action?.icon}
                  iconPosition="left"
                  className="justify-start"
                >
                  {action?.label}
                </Button>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* Overlay for dropdown */}
      {isExpanded && (
        <div 
          className="fixed inset-0 z-200"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </div>
  );
};

export default QuickActionToolbar;